import {
  BidDomainSelectModelSchema,
  BidDomainUpdateModelSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { SelectBidOutputSchema } from './select-bid.models.ts'

export const UpdateBidInputSchema = BidDomainSelectModelSchema.pick({
  bidId: true,
}).extend(
  BidDomainUpdateModelSchema.pick({
    amount: true,
    pitch: true,
    agencyTeamId: true,
  }).shape
)

export type UpdateBidInput = ZodInfer<typeof UpdateBidInputSchema>

export const UpdateBidOutputSchema = SelectBidOutputSchema

export type UpdateBidOutput = ZodInfer<typeof UpdateBidOutputSchema>
